export default class Duties {
  static attack = "Attack";
  static support = "Support";
  static defend = "Defend";
  static cover = "Cover";
  static stopper = "Stopper";
}
